import { http, HttpResponse } from 'msw'

import { allSites } from 'app/mocks/data/park/sites'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersSiteApi } from 'app/utils/park/site'

import { SitesRequest } from 'app/types/park/site'

export const getAllSites = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersSiteApi.MANAGERS,
        )
        const clientIdsFilter = searchParams.get(searchParametersSiteApi.CLIENT)

        const countriesFilter = searchParams.get(
            searchParametersSiteApi.COUNTRY,
        )

        const postalCodeFilter = searchParams.get(
            searchParametersSiteApi.POSTAL_CODE,
        )

        const cityFilter = searchParams.get(searchParametersSiteApi.CITY)
        const addressFilter = searchParams.get(searchParametersSiteApi.ADDRESS)
        const nameFilter = searchParams.get(searchParametersSiteApi.NAME)
        const hasOrder = searchParams.get(searchParametersSiteApi.HAS_ORDER)

        let allSitesFiltered = allSites

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allSitesFiltered = allSitesFiltered.filter((site) =>
                managerIdsSplit.includes(site.customer_name.client.id),
            )
        }

        // Client filter
        if (clientIdsFilter) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilter)

            allSitesFiltered = allSitesFiltered.filter((site) =>
                clientIdsSplit.includes(site.customer_name.id),
            )
        }

        // Countries filter
        if (countriesFilter) {
            const countriesSplit = countriesFilter.split(',')

            allSitesFiltered = allSitesFiltered.filter((site) =>
                countriesSplit.includes(site.country),
            )
        }

        // Postal code filter
        if (postalCodeFilter) {
            allSitesFiltered = allSitesFiltered.filter((site) =>
                site.postal_code.toString().includes(postalCodeFilter),
            )
        }

        // City filter
        if (cityFilter) {
            allSitesFiltered = allSitesFiltered.filter((site) =>
                site.city.toLowerCase().includes(cityFilter.toLowerCase()),
            )
        }

        // Address filter
        if (addressFilter) {
            allSitesFiltered = allSitesFiltered.filter((site) =>
                site.address
                    .toLowerCase()
                    .includes(addressFilter.toLowerCase()),
            )
        }

        // Name filter
        if (nameFilter) {
            allSitesFiltered = allSitesFiltered.filter((site) =>
                site.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Has order filter
        if (hasOrder) {
            allSitesFiltered = allSitesFiltered.filter(
                (site) => site.has_order.toString() === hasOrder,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allSitesFiltered.length > limit
                ? offset + limit
                : allSitesFiltered.length

        const results = allSitesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allSitesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<SitesRequest>({
            next,
            results,
        })
    },
)
